/* Matraws — Sælg din samling interactions. Auto-generated. */
(function(){ if (window.__mtwInit) return; window.__mtwInit = 1;
function init(){

/* reveal-on-scroll (this lightweight version CAN ship with the page) */
(function(){
  var els = document.querySelectorAll('[data-mtwreveal]');
  if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target);} });
  }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(e){ io.observe(e); });
})();

/* count-up stats */
(function(){
  var nums = document.querySelectorAll('[data-count]');
  if(!nums.length) return;
  function run(el){
    var target = parseInt(el.getAttribute('data-count'),10), start = null, dur = 1100;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var eased = 1 - Math.pow(1-p, 3);
      el.textContent = Math.round(target*eased);
      if(p<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if(!('IntersectionObserver' in window)){ nums.forEach(function(n){n.textContent=n.getAttribute('data-count');}); return; }
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ run(e.target); io.unobserve(e.target);} });
  }, { threshold: .6 });
  nums.forEach(function(n){ io.observe(n); });
})();


}
if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
